//================ show info popup js code ==================

document.addEventListener("DOMContentLoaded", function () {
  const popupContainers = document.querySelectorAll(".cstm_show_info_pop");
  const closeBtn = document.querySelector(".info_pop_close");
  // console.log(popupContainers.length, "popupContainers length");
  if (popupContainers.length > 0) {
    popupContainers.forEach(function (container) {
      const popups = container.querySelectorAll(".info_pop_conn");
      const clickableElements = container.querySelectorAll(".multicolumn-card");
      // console.log(clickableElements.length, "clickableElements length");
      clickableElements.forEach(function (clickableElement, index) {
        clickableElement.addEventListener("click", function () {
        //  const classPresent =  popups[index].classList.contains('popup_hidden');
          // Show the specific popup
          if( popups[index]){
            popups[index].style.display = "flex";
            document.body.style.overflow = "hidden";
            closeBtn.style.display = "flex";
            // console.log('Popup displayed for the clicked clickable element');
          }
        });
      });
        // console.log(closeBtn);
          if (closeBtn) {
            closeBtn.addEventListener('click', function(){
              document.body.style.overflow = "unset";
              const p = container.querySelectorAll(".info_pop_conn");
              closeBtn.style.display = "none";
              popups.forEach((close)=>{
                close.style.display = 'none';
              });
            });
          }
    });
  }
});



   